/*
  Dos Peces - Theme JS
  Carrito real usando la Shopify AJAX Cart API (/cart/add.js, /cart.js, /cart/change.js)
*/

const settings = window.themeSettings || {};
const FREE_SHIPPING_THRESHOLD = settings.freeShippingThreshold || 60000;
const SHIPPING_COST = settings.shippingCost || 3000;
const routes = settings.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

const fmt = n => "$" + Math.round(n).toLocaleString("es-CL");

function resizeImage(url, width) {
  if (!url) return url;
  try {
    const u = new URL(url, window.location.origin);
    u.searchParams.set('width', width);
    return u.toString();
  } catch (e) {
    return url;
  }
}

// ---------------------------------------------------------------------------
// Shopify AJAX Cart API
// ---------------------------------------------------------------------------

async function shopifyAdd(variantId, quantity) {
  const res = await fetch(routes.cartAdd + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] })
  });

  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.description || data.message || 'No se pudo agregar al carrito');
  }
  return data.items && data.items[0] ? data.items[0] : data;
}

async function fetchCart() {
  const res = await fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' } });
  return res.json();
}

async function changeCart(line, quantity) {
  const res = await fetch(routes.cartChange + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
  });

  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.description || data.message || 'No se pudo actualizar el carrito');
  }
  return data;
}

// ---------------------------------------------------------------------------
// UI helpers
// ---------------------------------------------------------------------------

function showToast(text) {
  const t = document.getElementById("toast");
  if (t) {
    document.getElementById("toast-text").textContent = text;
    t.classList.add("show");
    clearTimeout(window._toastTimer);
    window._toastTimer = setTimeout(() => t.classList.remove("show"), 2200);
  }
}

function selectVariant(btn) {
  const card = btn.closest(".card");
  card.querySelectorAll(".variant").forEach(v => v.classList.remove("sel"));
  btn.classList.add("sel");

  // El selector debe ser explícito: los botones .variant también llevan
  // data-price, y tras restructureCardsToHorizontal() quedan antes del precio.
  const priceEl = card.querySelector(".price[data-price]");
  const price = parseInt(btn.dataset.price) / 100;
  const compare = parseInt(btn.dataset.compare || "0") / 100;
  const wasHTML = compare > price ? `<s>${fmt(compare)}</s>` : "";
  const offHTML = compare > price ? ` <em>-${Math.round((compare - price) / compare * 100)}%</em>` : "";

  if (priceEl) priceEl.innerHTML = `${wasHTML}${fmt(price)}${offHTML}`;
  card.querySelector(".add-cart").dataset.defaultVariant = btn.dataset.variantId;
}

function stepQty(btn, dir) {
  const inp = btn.parentElement.querySelector("input");
  inp.value = Math.max(1, (parseInt(inp.value) || 1) + dir);
}

async function addToCartFromCard(btn) {
  const card = btn.closest(".card");
  const variantId = btn.dataset.defaultVariant;
  const qty = parseInt(card.querySelector("[data-qty]").value) || 1;

  btn.disabled = true;
  const orig = btn.textContent;
  btn.textContent = "...";

  try {
    const item = await shopifyAdd(variantId, qty);
    showToast("Agregado: " + (item.product_title || "producto"));
    await renderCart();
    openCart();
  } catch (err) {
    showToast(err.message);
  } finally {
    btn.disabled = false;
    btn.textContent = orig;
  }
}

async function addToCartSimple(btn) {
  const variantId = btn.dataset.variantId;
  btn.disabled = true;
  try {
    const item = await shopifyAdd(variantId, 1);
    showToast("Agregado: " + (item.product_title || "producto"));
    await renderCart();
    openCart();
  } catch (err) {
    showToast(err.message);
  } finally {
    btn.disabled = false;
  }
}

function renderFreeShipBar(subtotal) {
  const msg = document.getElementById("free-ship-msg");
  const bar = document.getElementById("free-ship-progress");
  if (!msg || !bar) return;

  if (subtotal >= FREE_SHIPPING_THRESHOLD) {
    msg.innerHTML = "🎉 ¡Tienes <strong>envío gratis</strong> en Zona Oriente!";
    bar.style.width = "100%";
  } else {
    msg.innerHTML = `Te faltan <strong>${fmt(FREE_SHIPPING_THRESHOLD - subtotal)}</strong> para envío gratis en Zona Oriente`;
    bar.style.width = Math.min(100, Math.round(subtotal / FREE_SHIPPING_THRESHOLD * 100)) + "%";
  }
}

async function renderCart(cartData) {
  const cart = cartData || await fetchCart();
  const body = document.getElementById("cart-body");
  const foot = document.getElementById("cart-foot");
  const countEl = document.getElementById("cart-count");

  if (countEl) {
    countEl.textContent = cart.item_count;
    countEl.classList.toggle("is-empty", cart.item_count === 0);
  }

  if (!body) return;

  if (cart.item_count === 0) {
    body.innerHTML = `
      <div class="cart-empty">
        <div class="ico">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M5 7h14l-1.5 11a2 2 0 0 1-2 1.7H8.5a2 2 0 0 1-2-1.7L5 7Z"/><path d="M9 7V5a3 3 0 0 1 6 0v2"/></svg>
        </div>
        <p>Tu carrito está vacío.</p>
        <a href="${routes.allProducts || '/collections/all'}" class="cart-empty-cta">Ver el catálogo →</a>
      </div>`;
    if (foot) foot.style.display = "none";
    return;
  }

  body.innerHTML = cart.items.map((it, idx) => {
    const line = idx + 1;
    const img = it.image ? `<img src="${resizeImage(it.image, 128)}" alt="" loading="lazy">` : "";
    const variant = it.variant_title && it.variant_title !== "Default Title" ? `<div class="var">${it.variant_title}</div>` : "";

    return `
      <div class="cart-item">
        <div class="thumb">${img}</div>
        <div class="info">
          <h5>${it.product_title}</h5>
          ${variant}
          <div class="row">
            <div class="stepper">
              <button type="button" onclick="cartChange(${line}, ${it.quantity - 1})">−</button>
              <input type="number" value="${it.quantity}" min="1" onchange="cartSet(${line}, this.value)">
              <button type="button" onclick="cartChange(${line}, ${it.quantity + 1})">+</button>
            </div>
            <div>
              <div class="price-line">${fmt(it.final_line_price / 100)}</div>
              <button class="remove" type="button" onclick="cartChange(${line}, 0)">Eliminar</button>
            </div>
          </div>
        </div>
      </div>`;
  }).join("");

  const subtotal = cart.items_subtotal_price / 100;

  document.getElementById("subtotal").textContent = fmt(subtotal);
  const shipEl = document.getElementById("shipping");
  if (shipEl) shipEl.textContent = "Se calcula en el checkout";
  document.getElementById("total").textContent = fmt(subtotal);
  renderFreeShipBar(subtotal);
  if (foot) foot.style.display = "block";
}

async function cartChange(line, quantity) {
  try {
    const cart = await changeCart(line, Math.max(0, parseInt(quantity)));
    await renderCart(cart);
  } catch (err) {
    showToast(err.message);
    await renderCart();
  }
}

async function cartSet(line, val) {
  const q = Math.max(1, parseInt(val) || 1);
  await cartChange(line, q);
}

function openCart() {
  document.getElementById("cart-drawer").classList.add("open");
  document.querySelector(".cart-overlay").classList.add("open");
  document.body.style.overflow = "hidden";
}

function closeCart() {
  document.getElementById("cart-drawer").classList.remove("open");
  document.querySelector(".cart-overlay").classList.remove("open");
  document.body.style.overflow = "";
}

// ---------------------------------------------------------------------------
// Mobile menu
// ---------------------------------------------------------------------------

function openMobileMenu() {
  const menu = document.getElementById("mobile-menu");
  const overlay = document.querySelector(".mobile-overlay");
  if (menu) menu.classList.add("open");
  if (overlay) overlay.classList.add("open");
  document.body.style.overflow = "hidden";
}

function closeMobileMenu() {
  const menu = document.getElementById("mobile-menu");
  const overlay = document.querySelector(".mobile-overlay");
  if (menu) menu.classList.remove("open");
  if (overlay) overlay.classList.remove("open");
  const cart = document.getElementById("cart-drawer");
  if (!cart || !cart.classList.contains("open")) {
    document.body.style.overflow = "";
  }
}

// ---------------------------------------------------------------------------
// Product page
// ---------------------------------------------------------------------------

function selectProductVariant(btn) {
  const info = btn.closest(".product-info");
  info.querySelectorAll(".variant").forEach(v => v.classList.remove("sel"));
  btn.classList.add("sel");

  const idInput = document.getElementById("product-variant-id");
  if (idInput) idInput.value = btn.dataset.variantId;

  const priceEl = document.getElementById("product-price");
  if (priceEl) {
    const price = parseInt(btn.dataset.price) / 100;
    const compare = parseInt(btn.dataset.compare || "0") / 100;
    const wasHTML = compare > price ? `<s>${fmt(compare)}</s> ` : "";
    priceEl.innerHTML = `${wasHTML}${fmt(price)}`;
  }
}

function swapProductImage(btn) {
  const main = document.getElementById("product-main-image");
  if (main && btn.dataset.src) {
    main.src = btn.dataset.src;
  }
}

function initProductForms() {
  document.querySelectorAll("form[data-ajax-product-form]").forEach(form => {
    form.addEventListener("submit", async e => {
      e.preventDefault();
      const idInput = form.querySelector('[name="id"]');
      const qtyInput = form.querySelector('[name="quantity"]');
      const submitBtn = form.querySelector('button[type="submit"]');
      if (!idInput) return;

      const qty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
      const orig = submitBtn ? submitBtn.textContent : "";
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "...";
      }

      try {
        const item = await shopifyAdd(idInput.value, qty);
        showToast("Agregado: " + (item.product_title || "producto"));
        await renderCart();
        openCart();
      } catch (err) {
        showToast(err.message);
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = orig;
        }
      }
    });
  });
}

// ---------------------------------------------------------------------------
// Navigation / sections
// ---------------------------------------------------------------------------

function setActiveNav() {
  const links = document.querySelectorAll('.nav-links a[href^="#"]');
  if (!links.length) return;
  const sections = [...links].map(a => a.getAttribute("href").slice(1)).map(id => document.getElementById(id)).filter(Boolean);
  const y = window.scrollY + 120;
  let current = sections[0];
  for (const s of sections) {
    if (s && s.offsetTop <= y) {
      current = s;
    }
  }
  links.forEach(a => a.classList.toggle("active", current && a.getAttribute("href") === "#" + current.id));
}

function toggleCategory(categoryId) {
  const section = document.getElementById(categoryId);
  if (section) {
    section.classList.toggle('collapsed');
  }
}

function openDeliveryModal() {
  const modal = document.getElementById("delivery-modal-overlay");
  if (modal) {
    modal.classList.add("open");
    document.body.style.overflow = "hidden";
  }
}

function closeDeliveryModal() {
  const modal = document.getElementById("delivery-modal-overlay");
  if (modal) {
    modal.classList.remove("open");
    const cart = document.getElementById("cart-drawer");
    if (!cart || !cart.classList.contains("open")) {
      document.body.style.overflow = "";
    }
  }
}

// ---------------------------------------------------------------------------
// Horizontal card restructuring (visual layout)
// ---------------------------------------------------------------------------

function restructureCardsToHorizontal() {
  // 1. Restructure standard .card elements
  document.querySelectorAll('.card').forEach(card => {
    if (card.classList.contains('horizontal-card')) return;

    const img = card.querySelector('.img');
    const cardRow = card.querySelector('.card-row');
    const titleEl = cardRow ? cardRow.querySelector('h3') : null;
    const priceEl = cardRow ? cardRow.querySelector('[data-price]') : null;
    const descEl = card.querySelector('.card-desc');
    const variantsEl = card.querySelector('.variants');
    const ctaEl = card.querySelector('.cta');

    if (!cardRow || !titleEl) return;

    // Create right-side container
    const infoContainer = document.createElement('div');
    infoContainer.className = 'card-info';

    // Move title
    titleEl.style.margin = '0';
    infoContainer.appendChild(titleEl);

    // Move description if it exists
    if (descEl) infoContainer.appendChild(descEl);

    // Move variants if they exist
    if (variantsEl) infoContainer.appendChild(variantsEl);

    // Create a bottom row for Price and Action
    const bottomRow = document.createElement('div');
    bottomRow.className = 'card-bottom-row';

    // Move price to bottom row
    if (priceEl) bottomRow.appendChild(priceEl);

    // Create the circular teal plus button
    const plusBtn = document.createElement('button');
    plusBtn.type = 'button';
    plusBtn.className = 'add-mini-circle';
    plusBtn.innerHTML = '+';
    plusBtn.ariaLabel = 'Agregar al carrito';

    if (ctaEl) {
      const originalAddBtn = ctaEl.querySelector('.add-cart');
      if (originalAddBtn) {
        if (originalAddBtn.disabled) plusBtn.disabled = true;
        plusBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          originalAddBtn.click();
        });
      }
    }

    bottomRow.appendChild(plusBtn);
    infoContainer.appendChild(bottomRow);

    // Clear card and re-assemble
    card.innerHTML = '';
    card.appendChild(img);
    card.appendChild(infoContainer);

    // Hide original CTA in DOM
    if (ctaEl) {
      ctaEl.style.display = 'none';
      card.appendChild(ctaEl);
    }

    // Adapt tags on the image to circles/pills
    if (img) {
      const tagEl = img.querySelector('.tag');
      if (tagEl) {
        const text = tagEl.textContent.trim();
        if (text.includes('%') || text.includes('OFF') || text.includes('OFERTA') || !isNaN(text)) {
          tagEl.className = 'tag tag-circle';
          if (text.includes('%')) {
            const match = text.match(/\d+%/);
            if (match) tagEl.textContent = "-" + match[0];
          } else if (text === "OFERTA") {
            tagEl.textContent = "%";
          }
        } else {
          tagEl.className = 'tag tag-pill';
        }
      }
    }

    card.classList.add('horizontal-card');
  });

  // 2. Restructure list .menu-item elements
  document.querySelectorAll('.menu-item').forEach(item => {
    if (item.classList.contains('horizontal-card')) return;

    const thumb = item.querySelector('.thumb');
    const titleEl = item.querySelector('h4');
    const descEl = item.querySelector('p');
    const priceEl = item.querySelector('.price');
    const addBtn = item.querySelector('.add-mini');

    if (!titleEl || !thumb) return;

    // Create new .img container to match card structure
    const imgDiv = document.createElement('div');
    imgDiv.className = 'img';
    const imgLink = thumb.querySelector('a');
    const img = thumb.querySelector('img');
    if (imgLink) {
      imgDiv.appendChild(imgLink);
    } else if (img) {
      imgDiv.appendChild(img);
    }

    // Create card info container
    const infoContainer = document.createElement('div');
    infoContainer.className = 'card-info';

    // Title (preserve link if present)
    const title = document.createElement('h3');
    const titleLink = titleEl.querySelector('a');
    if (titleLink) {
      title.appendChild(titleLink);
    } else {
      title.textContent = titleEl.textContent;
    }
    infoContainer.appendChild(title);

    // Description
    if (descEl) {
      const desc = document.createElement('p');
      desc.className = 'card-desc';
      desc.textContent = descEl.textContent;
      infoContainer.appendChild(desc);
    }

    // Bottom row for Price and Circle Plus Button
    const bottomRow = document.createElement('div');
    bottomRow.className = 'card-bottom-row';

    if (priceEl) {
      // Parse discount em inside priceEl if it exists
      const emEl = priceEl.querySelector('em');
      if (emEl) {
        const text = emEl.textContent.trim();
        const tagEl = document.createElement('span');
        tagEl.className = 'tag tag-circle';
        tagEl.textContent = text;
        imgDiv.appendChild(tagEl);
        emEl.remove();
      }
      bottomRow.appendChild(priceEl);
    }

    // Plus button
    const plusBtn = document.createElement('button');
    plusBtn.type = 'button';
    plusBtn.className = 'add-mini-circle';
    plusBtn.innerHTML = '+';
    plusBtn.ariaLabel = 'Agregar al carrito';

    if (addBtn) {
      if (addBtn.disabled) plusBtn.disabled = true;
      plusBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        addBtn.click();
      });
    }
    bottomRow.appendChild(plusBtn);
    infoContainer.appendChild(bottomRow);

    // Clear and assemble
    item.innerHTML = '';
    item.appendChild(imgDiv);
    item.appendChild(infoContainer);

    if (addBtn) {
      addBtn.style.display = 'none';
      item.appendChild(addBtn);
    }

    item.className = 'card horizontal-card';
  });
}

// ---------------------------------------------------------------------------
// Global exposure for inline event handlers
// ---------------------------------------------------------------------------

window.stepQty = stepQty;
window.selectVariant = selectVariant;
window.selectProductVariant = selectProductVariant;
window.swapProductImage = swapProductImage;
window.addToCartFromCard = addToCartFromCard;
window.addToCartSimple = addToCartSimple;
window.cartChange = cartChange;
window.cartSet = cartSet;
window.openCart = openCart;
window.closeCart = closeCart;
window.openMobileMenu = openMobileMenu;
window.closeMobileMenu = closeMobileMenu;
window.toggleCategory = toggleCategory;
window.openDeliveryModal = openDeliveryModal;
window.closeDeliveryModal = closeDeliveryModal;

document.addEventListener("DOMContentLoaded", () => {
  restructureCardsToHorizontal();
  renderCart();
  initProductForms();
  window.addEventListener("scroll", setActiveNav, { passive: true });
  setActiveNav();

  // Expand category based on URL hash
  function expandCategoryFromHash() {
    const hash = window.location.hash;
    if (hash) {
      const targetId = hash.substring(1);
      const section = document.getElementById(targetId);
      if (section && section.classList.contains('category-section')) {
        section.classList.remove('collapsed');
      }
    }
  }

  expandCategoryFromHash();
  window.addEventListener("hashchange", expandCategoryFromHash);

  // Cerrar el menú móvil al navegar por un link interno
  document.querySelectorAll(".mobile-menu-links a").forEach(a => {
    a.addEventListener("click", closeMobileMenu);
  });

  // Re-run after the theme editor re-renders a section
  document.addEventListener("shopify:section:load", () => {
    restructureCardsToHorizontal();
    initProductForms();
  });
});
